var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"EmptyRequest w-100 h-100 p-0 row center-xs center-md center-sm center-xs mt-3"},[_c('img',{staticClass:"empty",attrs:{"src":_vm.emptyIcon}}),(!_vm.hasFilters)?_c('span',[_vm._v("Não há "+_vm._s(_vm.dataTitle)+" para exibir.")]):_c('span',[_vm._v("Não há "+_vm._s(_vm.dataTitle)+" correspondentes a busca para exibir.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }